module.exports = __webpack_public_path__ + "static/img/gift2.c546d3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/activity/shuang12/gift2.png
// module id = kIQx
// module chunks = 86